import React from 'react';
import { Settings, Users, Activity, Film, Key, Wrench, LogOut, Shield, BarChart3, Video, Building2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

const Sidebar = ({ activeTab, setActiveTab }) => {
  const { user, logout, environment, environments, switchEnvironment } = useAuth();

  const navItems = [
    { id: 'access-control', icon: Shield, label: 'Access Control' },
    { id: 'settings', icon: Settings, label: 'Settings' },
    { id: 'workers', icon: Activity, label: 'Workers' },
    { id: 'users', icon: Users, label: 'Users' },
    { id: 'organizations', icon: Building2, label: 'Organizations' },
    { id: 'video-tasks', icon: Film, label: 'Video Tasks' },
    { id: 'demo-videos', icon: Video, label: 'Demo Videos' },
    { id: 'api-keys', icon: Key, label: 'API Keys' },
    { id: 'maintenance', icon: Wrench, label: 'Maintenance' },
    { id: 'telemetry', icon: BarChart3, label: 'Telemetry' },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h1 className="sidebar-title">QARL Studio</h1>
        <p className="sidebar-subtitle">Admin Dashboard</p>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`nav-item ${activeTab === item.id ? 'nav-item-active' : ''}`}
            >
              <Icon className="nav-icon" />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user?.email?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="user-details">
            <p className="user-name">{user?.displayName || 'Admin'}</p>
            <p className="user-email">{user?.email}</p>
          </div>
        </div>
        <div className="env-selector">
          <label className="env-label">Environment</label>
          <select
            value={environment}
            onChange={(e) => switchEnvironment(e.target.value)}
            className="env-select"
          >
            {Object.entries(environments).map(([key, env]) => (
              <option key={key} value={key}>{env.label}</option>
            ))}
          </select>
        </div>
        <button onClick={logout} className="logout-button">
          <LogOut className="nav-icon" />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;